/* DON'T EDIT THIS FILE: edit original and run build again */ import React, { useContext } from "react";

export const RequiredActionsContext = React.createContext({
  hasRequiredActions: false,
});

export const useRequiredActionsCached = () =>
  useContext(RequiredActionsContext);
